module.exports = __webpack_public_path__ + "static/media/viber-filled.525a52df.svg";